const HistoryType = Object.freeze({
    IMAGE: 'image',
    COLOR: 'color',
    SELECTION: 'selection'
});

export default HistoryType;